import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
      <div className="card max-w-md p-8 text-center">
        <h1 className="text-2xl font-semibold text-slate-900">404</h1>
        <p className="mt-2 text-sm text-slate-600">
          We couldn’t find the page you were looking for.
        </p>
        <Link to="/myapps" className="btn-primary mt-4 inline-flex">
          Back to My Apps
        </Link>
      </div>
    </div>
  );
}
